export const MICRO_TOKEN = 1_000_000; // TODO: based on mint address
